import { SALES_PAGE_STATUS } from "ui/pages/SalesPages/constants";

const TRAFFIC_LINK_REDIRECT_TYPE_ENUM = {
  HOME_PAGE: 1,
  LISTING: 2,
  SALES_PAGE: 3,
  PLAN: 4,
};

export const TRAFFIC_LINK_REDIRECT_TYPE = {
  HOME_PAGE: {
    value: TRAFFIC_LINK_REDIRECT_TYPE_ENUM.HOME_PAGE,
    id: TRAFFIC_LINK_REDIRECT_TYPE_ENUM.HOME_PAGE,
    label: "Home Page",
    key: TRAFFIC_LINK_REDIRECT_TYPE_ENUM.HOME_PAGE,
  },
  LISTING: {
    value: TRAFFIC_LINK_REDIRECT_TYPE_ENUM.LISTING,
    id: TRAFFIC_LINK_REDIRECT_TYPE_ENUM.LISTING,
    label: "Offering",
    key: TRAFFIC_LINK_REDIRECT_TYPE_ENUM.LISTING,
  },
  SALES_PAGE: {
    value: TRAFFIC_LINK_REDIRECT_TYPE_ENUM.SALES_PAGE,
    id: TRAFFIC_LINK_REDIRECT_TYPE_ENUM.SALES_PAGE,
    label: "Landing Page",
    key: TRAFFIC_LINK_REDIRECT_TYPE_ENUM.SALES_PAGE,
  },
  PLAN: {
    value: TRAFFIC_LINK_REDIRECT_TYPE_ENUM.PLAN,
    id: TRAFFIC_LINK_REDIRECT_TYPE_ENUM.PLAN,
    label: "Plan",
    key: TRAFFIC_LINK_REDIRECT_TYPE_ENUM.PLAN,
  },
};

export const SALES_PAGE_STATUSES_TO_SHOW = [
  SALES_PAGE_STATUS.LIVE,
  SALES_PAGE_STATUS.SOLD_OUT,
];

export const TRAFFIC_ANALYSIS_LEARN_MORE_HREFS = {
  TRAFFIC_ANALYSIS:
    "https://support.exlyapp.com/support/solutions/articles/84000372465-traffic-analysis-with-exly",
  TRAFFIC_ANALYSIS_VIDEO: "https://www.youtube-nocookie.com/embed/IgW9FtMWS24",
};

export const STAT_CARDS = {
  VIEWS: {
    title: "Total Visitors",
  },
  LEADS: {
    title: "Total Leads",
  },
  BOOKINGS: {
    title: "Total Bookings",
  },
  REVENUE: {
    title: "Total Revenue",
  },
};

export const date_range_select_options = {
  last_7: { value: "last_7", label: "Last 7 days", days: 7 },
  last_30: { value: "last_30", label: "Last 30 days", days: 30 },
  lifetime: { value: "last_365", label: "Last 1 year", days: 365 },
  custom: { value: "custom", label: "Custom" },
};

export const DAYS_RANGE = {
  six: 6,
  twentyNine: 29,
  one: 1,
};

export const TRAFFIC_ANALYSIS_STATS = "trafficAnalysisStats";

export const AFFILIATE_SHARE_HEADER_IMG = "reward.png";
export const AFFILIATE_HEADER_TITLE = "Share it with your audience!";
export const AFFILIATE_COPY_LISTING_PAGE_CTA_TEXT = "Copy Link";
export const TRACKING_SUMMARY = "trackingSummary";
